/**
 * Head component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

import favicon from '../images/favicon.ico'

function Head({ title, description, lang, meta }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )
  
  const url = process.env.GATSBY_REPLACEMENT_URL;
  const metaDescription = description || site.siteMetadata.description

  let ogimage, twitterImage;
  ogimage = twitterImage = {'src': '', 'height': '', 'width' : ''}
  if(meta.opengraphImage && meta.opengraphImage.localFile) {
    if( meta.opengraphImage.localFile.childImageSharp)
      ogimage = twitterImage = meta.opengraphImage.localFile.childImageSharp.original;
    else
      ogimage = twitterImage = meta.opengraphImage.localFile.publicURL;
  }

  if(meta.twitterImage && meta.twitterImage.localFile) {
    if( meta.twitterImage.localFile.childImageSharp)
      twitterImage = meta.twitterImage.localFile.childImageSharp.original;
    else
      twitterImage = meta.opengraphImage.localFile.publicURL
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: 'keywords',
          content: meta.focuskw,
        },
        {
          name: 'article:modified_time',
          content: meta.opengraphModifiedTime
        },

        /* Open Graph */
        {
          property: `og:site_name`,
          content: title,
        },
        {
          property: `og:title`,
          content: meta.opengraphTitle,
        },
        {
          property: `og:description`,
          content: meta.opengraphDescription,
        },
        {
          property: `og:url`,
          content: meta.opengraphUrl,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: url+ogimage.src,
        },
        {
          property: `og:image:width`,
          content: ogimage.width,
        },
        {
          property: `og:image:height`,
          content: ogimage.height,
        },


        /* Twitter */
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: meta.twitterTitle || title,
        },
        {
          name: `twitter:description`,
          content: meta.twitterDescription || metaDescription,
        },
        {
          name: `twitter:image`,
          content: url+twitterImage.src,
        },
        {
          name: `twitter:image:width`,
          content: twitterImage.width,
        },
        {
          name: `twitter:image:height`,
          content: twitterImage.height,
        },
        

      ]}
      link={[
        {"rel": "icon", 
         "type": "image/png", 
         "href": favicon
        }
      ]}
    />
  )
}

Head.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Head.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default Head
